export const isServer = () => typeof process !== "undefined" && process.server
